module.exports = __webpack_public_path__ + "img/Contact_Email_ID.32fd4cf3.svg";